export enum BasketAction {
    ADD = 1,
    REMOVE = 2,
    CHANGE_QTY = 3
}
